import * as yup from "yup";
import { TargetType } from "features/RecordTarget/models";

export const buildRecordTargetSchema = (targetTypeLabel: string, required: boolean) => yup.object().shape({
  targetType: yup.mixed<TargetType>().notRequired().label(targetTypeLabel),
  targetId: yup.string().when("targetType", (_, innerSchema, { parent }) => {
    switch (parent?.targetType) {
      case "User":
        return innerSchema.notRequired().label("User");
      case "MessageServiceChannel":
        return innerSchema.notRequired().label("Message Channel");
      case "OnboardingJourneyNetworkRelation":
        return innerSchema.notRequired().label("Onboarding Role");
      default:
        return innerSchema.notRequired();
    }
  }),
}).nullable().test("hasTarget", `${targetTypeLabel} is a required field`, (value) => {
  if (!required) {
    return true;
  }
  const hasTargetType = !!value?.targetType;
  const hasTargetId = !!value?.targetId;

  return hasTargetType && hasTargetId;
});

export type Schema = yup.InferType<ReturnType<typeof buildRecordTargetSchema>>;
